function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedShareBedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.286 17.133V6.857a3.43 3.43 0 00-3.429-3.428H9.143a3.43 3.43 0 00-3.429 3.428v10.284l-.912.686c-.944.71-1.373 1.48-1.373 2.47v4.857H28.57v-4.857c0-.984-.423-1.748-1.383-2.477l-.902-.687zm4.571 13.736h-2.286V27.44H3.43v3.428H1.143v-10.57c0-1.864.903-3.258 2.286-4.298V6.857a5.716 5.716 0 015.714-5.714h13.714a5.716 5.716 0 015.714 5.714V16c1.383 1.051 2.286 2.434 2.286 4.297V30.87z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8c-.946 0-1.714.769-1.714 1.714 0 .946.768 1.714 1.714 1.714.945 0 1.714-.768 1.714-1.714C13.714 8.77 12.945 8 12 8zM8 9.714c0-2.208 1.792-4 4-4s4 1.792 4 4-1.792 4-4 4-4-1.792-4-4zM21.143 10.057c-.436 0-.8.364-.8.8 0 .439.358.8.8.8.435 0 .8-.364.8-.8 0-.436-.365-.8-.8-.8zm-2.629.8a2.636 2.636 0 012.629-2.628 2.636 2.636 0 012.628 2.628 2.636 2.636 0 01-2.628 2.629 2.63 2.63 0 01-2.629-2.629zM26.286 17.143H5.714v-2.286h20.572v2.286z",
    fill: props.color
  }));
}

export default SvgIconBedShareBedFilled;